export default "__VITE_ASSET__BMly7VQA__"